import React, { Component } from "react";
import { Col } from "reactstrap";
import "./title.css";
import anime from "animejs/lib/anime.es.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faInstagram } from "@fortawesome/free-brands-svg-icons";
import Zoom from 'react-reveal/Zoom'; // Importing Zoom effect

export default class Title extends Component {
  state = { count: 7 };

  checkCount() {
    var timeleft = 4;

    var downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        setTimeout(() => {
          this.textAnime();
        }, 100);
      } else {
        timeleft -= 1;
        console.log(timeleft);
        this.setState({ count: this.state.count - 1 });
      }
    }, 500);
  }
  componentDidMount() {
    this.checkCount();
  }

  textAnime() {
    var textWrapper = document.querySelector(".ml9 .letters2");
    textWrapper.innerHTML = textWrapper.textContent.replace(
      /\S/g,
      `<span class="letter">$&</span>`
    );

    anime
      .timeline({ loop: true })
      .add({
        targets: ".ml9 .letter",
        scale: [0, 1],
        duration: 1500,
        elasticity: 600,
        delay: (el, i) => 45 * (i + 1),
      })
      .add({
        targets: ".ml9",
        opacity: 0,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 1000,
      });
  }

  render() {
    return (
      <Zoom>
          <div className="title_part">
        <div className="img fade_s">
        <Col xl="12" className="title-imp imp1">
            <h3 className="ml9">
              <span className="text-wrapper white-text">
                <span className="letters2 white-text fade_s">
                  Hı I'm Ahmet Aksu
                </span>
              </span>
            </h3>

          </Col>
          <div className="text-left text-light social-t t1 t2">
            <a
              className="align text-f h-100"
              href="https://www.instagram.com/ahmetaksu001/"
              rel="noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                size="3x"
                className="html_icon mr-2 mb-0 medias medias2"
              />
            </a>
          </div>
          <div className="text-left text-light social-t t1">
            <a
              className="align text-f"
              href="https://github.com/AhmetAksu375"
              rel="noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                icon={faGithub}
                size="3x"
                className="html_icon mr-2 mb-0 medias medias2"
              />
            </a>
          </div>
          <Col xl="12" className="title-imp">
        
            <hr className="line w-25"></hr>
            <a href="#about" className="arrow">
              <p
                className="ca3-scroll-down-link scroll-text text-white"
                data-ca3_iconfont="ETmodules"
                data-ca3_icon=""
              >
                Scroll Down
              </p></a>
              <a
              href="#about"
                className="ca3-scroll-down-link ca3-scroll-down-arrow"
                data-ca3_iconfont="ETmodules"
                data-ca3_icon=""
              ><br></br></a>
            
          </Col>
        </div>
      </div>
      </Zoom>
      
    );
  }
}
